// eslint-disable-next-line import/no-anonymous-default-export
export default {
    Aceitar: 0,
    EnviarResposta: 1,
    Responder: 2
}